import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Renderiza o alerta "alguem assinou um plano" para a equipe (admins +
 * vendedor). O subject e o proprio destinatario (User); o nome do assinante e do
 * plano vem de content() (data) para montar o texto e o excerpt.
 */
export default class PlanSubscribedAdminNotification extends Notification {
  icon() {
    return 'fas fa-user-plus';
  }
  href() {
    return app.route('marketplace.plans');
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.plan_subscribed_admin', {
      subscriber: data.subscriber,
      plan: data.plan_name
    });
  }
  excerpt() {
    return this.attrs.notification.content()?.plan_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/PlanSubscribedAdminNotification', PlanSubscribedAdminNotification);